import { Component, Input, OnInit } from '@angular/core';
import { ProductCard } from '../../../product/models/product-card';
import { PHPermissions } from '../../models/PHPermissions';
import { FormGroup } from '@angular/forms';
import { IGeneralInfoField, IProductCardForm } from '../../../product/models/models';
import { ServiceFeatures } from '../../models/serviceFeatures';
import { SessionService } from '../../services/session.service';
import { Utils } from '../../services/utils.service';

import { SHARED_MODULES } from '../../../shared.';
import { HasAccessPipe } from '../../pipes/has-access.pipe';
import { HasFeaturePipe } from '../../pipes/has-feature.pipe';
import { ProductTypeTitlePipe } from '../../pipes/product-type-title.pipe';
import { ImageSelectComponent } from '../image-select/image-select.component';

@Component({
    selector: 'app-product-general-info[product]',
    templateUrl: './product-general-info.component.html',
    styleUrls: ['./product-general-info.component.scss'],
	imports: [SHARED_MODULES, HasAccessPipe, HasFeaturePipe, ProductTypeTitlePipe, ImageSelectComponent],
    standalone: true
})
export class ProductGeneralInfoComponent implements OnInit {

	public fields: Array<IGeneralInfoField>;
	public showMoreMPs: boolean = false;
	public minMPDisplay: number = 5;
	public readonly permissions: typeof PHPermissions = PHPermissions;
	public readonly features: typeof ServiceFeatures = ServiceFeatures;

	@Input() productForm: FormGroup<IProductCardForm>;
	@Input() product: ProductCard;
	@Input() storeId: number;

	constructor(private sessionService: SessionService) {}

	ngOnInit(): void {
		this.fields = [
			{ name: 'ARTICLE', value: this.product.params.article },
			{ name: 'BARCODE', value: this.product.params.barcode },
			{ name: 'BRAND', value: this.product.params.brand_names },
			{ name: 'CATEGORY', value: this.product.params.category_paths }
		];

		if (this.sessionService.hasFeature(ServiceFeatures.Markers)) {
			this.fields.push({ name: 'CHARACTERISTIC', value: this.product.params.marker_paths });
		}

		if (!Utils.isNullOrUndefined(this.storeId)) {
			if (this.sessionService.hasFeature(ServiceFeatures.Suppliers)) {
				this.fields.push({ name: 'SUPPLIER', value: this.product.params.supplier_names });
			}

			if (this.sessionService.hasFeature(ServiceFeatures.ProductPrice)) {
				this.fields.push({ name: 'PRICE', value: String(this.product.params.price ?? '') });
			}

			if (this.sessionService.hasFeature(ServiceFeatures.ProductStock)) {
				this.fields.push({ name: 'STOCK', value: String(this.product.params.stock_qty ?? '') });
			}
		}
	}

	public onChangeImage(image: string): void {
		this.productForm.controls.photo.markAsDirty();
		this.productForm.controls.photo.setValue(image);
	}

	protected readonly length = length;
}
